module.exports = __webpack_public_path__ + "img/profile-user-red-but-actually-gray.5d1b9ffa.svg";